import { DatabaseConnectionsSectionFallback } from '@/routes/database/tabs/overview/sections/connections/fallback'
import { DatabaseDetailsSectionFallback } from '@/routes/database/tabs/overview/sections/details/fallback'
import { DatabaseManagePasswordSectionFallback } from '@/routes/database/tabs/overview/sections/manage-password/fallback'
import * as Styled from '@/routes/database/tabs/overview/styles'

export const OverviewTabFallback = () => {
  return (
    <Styled.PageLayoutContainer>
      <DatabaseDetailsSectionFallback />
      <DatabaseConnectionsSectionFallback />
      <DatabaseManagePasswordSectionFallback />
    </Styled.PageLayoutContainer>
  )
}
